import React, { useEffect, useState } from "react";
import ContentHeader from '../../components/ContentHeader'
import Loader from "../../components/Loader";
import Swal from "sweetalert2";
import Switch from "react-switch";
import axios from "axios";
import $ from 'jquery';
import "datatables.net-responsive-bs4";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";
import "select2/dist/js/select2";
import ImageNotFound from '../../assets/images/not-found.png';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const PageHome = () => {
    const [loading, setLoading] = useState(false);
    const [page_home_id, setPageHomeId] = useState(0);
    const [banner_title, setBannerTitle] = useState('');
    const [banner_sub_title, setBannerSubTitle] = useState('');
    const [banner_image, setBannerImage] = useState('');
    const [section_banner, setSectionBanner] = useState([]);
    const [service_title, setServiceTitle] = useState('');
    const [service_sub_title, setServiceSubTitle] = useState('');
    const [destination_title, setDestinationTitle] = useState('');
    const [destination_sub_title, setDestinationSubTitle] = useState('');
    const [discover_title, setDiscoverTitle] = useState('');
    const [discover_sub_title, setDiscoverSubTitle] = useState('');
    const [discover_description, setDiscoverDescription] = useState('');
    const [discover_video, setDiscoverVideo] = useState('');
    const [blog_title, setBlogTitle] = useState('');
    const [blog_sub_title, setBlogSubTitle] = useState('');
    const [about_title, setAboutTitle] = useState('');
    const [about_sub_title, setAboutSubTitle] = useState('');
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;
    const URLZFILES = process.env.REACT_APP_API_ZFILES;

    useEffect(() => {
        setTimeout(() => {
            $('.select2').select2({ width: "100%" });
        }, 100);
        getAll();
        getAbout();
        getBlogs();
        getServices();
        getDiscover();
        getPageUpdate();
        getDestinations();
    }, []);

    const getPageUpdate = async () => {
        await axios.get(ENDPOINT + 'get-home-page');
    };

    const getAll = async () => {
        setLoading(true);
        var table = $('.main').DataTable();
        table.destroy();
        await axios.get(ENDPOINT + "get-home-all-banners").then((response) => {
            setSectionBanner(response.data.data);
            setTimeout(() => {
                $('.main').DataTable({
                    searching: true,
                    destroy: true,
                    retrieve: true,
                    pageLength: 10,
                    responsive: true,
                    autoWidth: true,
                    paging: true,
                    ordering: true,
                    sortable: true,
                    processing: false,
                    serverSide: false,
                    bInfo: true,
                    language: {
                        "decimal": "",
                        "emptyTable": "",
                        "info": "Mostrando _START_ a _END_ de _TOTAL_ registros",
                        "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                        "infoFiltered": "(filtrado de un total de _MAX_ registros)",
                        "infoPostFix": "",
                        "thousands": ",",
                        "lengthMenu": "Mostrar _MENU_ registros",
                        "loadingRecords": "Cargando...",
                        "processing": "Procesando...",
                        "search": "Buscar:",
                        "paginate": {
                            "first": "<i class='fa-solid fa-circle-chevron-left'></i>",
                            "last": "<i class='fa-solid fa-circle-chevron-right'></i>",
                            "next": "<i class='fas fa-arrow-circle-right'></i>",
                            "previous": "<i class='fas fa-arrow-circle-left'></i>"
                        },
                        "zeroRecords": "No hay registros",
                        "searchPlaceholder": "Buscar por banner",
                    },
                });
                setLoading(false);
            }, 100);
        })
            .catch(function (error) {
                setLoading(false);
                console.log(error);
            });
    };
    
    
    const handleNew = () => {
        clearField();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const form = new FormData();
        form.append("banner_title", banner_title);
        form.append("banner_sub_title", banner_sub_title);
        form.append("banner_image", banner_image);
        if (page_home_id === 0) {
            await axios
                .post(ENDPOINT + "save-home-banner", form)
                .then((response) => {
                    getAll();
                    clearField();
                    setLoading(false);
                    getPageUpdate();
                    $("#closemodal").trigger("click");
                    Swal.fire({
                        icon: "success",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: false,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    setLoading(false);
                    Swal.fire({
                        icon: "error",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: true,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                });
        } else {
            setLoading(true);
            await axios
                .put(ENDPOINT + "update-home-banner/" + page_home_id, {
                    banner_title: banner_title,
                    banner_sub_title: banner_sub_title,
                    banner_image: banner_image
                })
                .then((response) => {
                    getAll();
                    clearField();
                    setLoading(false);
                    getPageUpdate();
                    $("#closemodal").trigger("click");
                    Swal.fire({
                        icon: "success",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: false,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    setLoading(true);
                    Swal.fire({
                        icon: "error",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: true,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                });
        }
    };

    const clearField = () => {
        setPageHomeId(0);
        setBannerTitle('');
        setBannerSubTitle('');
        setBannerImage('');
    };

    const toggleSwitch = async (val) => {
        setLoading(true);
        await axios
            .put(ENDPOINT + "get-home-banner-status/" + val)
            .then((response) => {
                getAll();
                setLoading(false);
                Swal.fire({
                    icon: "success",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: false,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
                Swal.fire({
                    icon: "error",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: true,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            });
    };

    const handleEdit = async (id) => {
        setLoading(true);
        await axios
            .get(ENDPOINT + "get-home-banner/" + id)
            .then((response) => {
                setLoading(false);
                setPageHomeId(response.data.data.page_home_id);
                setBannerTitle(response.data.data.banner_title);
                setBannerSubTitle(response.data.data.banner_sub_title);
                setBannerImage(response.data.data.banner_image);
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    };

    const handleDelete = (id, name) => {
        Swal.fire({
            title: `¿Desea eliminar el registro [ ${name} ] ?`,
            text: "No podrá recuperarlo",
            icon: "warning",
            confirmButtonText: "Sí, eliminarlo",
            confirmButtonColor: "#469408",
            showCancelButton: true,
            cancelButtonColor: "#c71c22",
            cancelButtonText: "No",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios
                    .delete(ENDPOINT + "delete-home-banner/" + id).then((response) => {
                        getAll();
                        setLoading(false);
                        Swal.fire({
                            icon: "success",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: false,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    })
                    .catch(function (error) {
                        setLoading(false);
                        Swal.fire({
                            icon: "error",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: true,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    });
            }
        });
    };

    const handleFileChange = async (e) => {
        setLoading(true);
        const form = new FormData();
        form.append('file', e.target.files[0]);
        form.append('destination', 'zfiles/banners/');
        await axios.post(ENDPOINT + 'upload-home-banner', form, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => {
            setBannerImage(response.data.data.pathFile);
            setLoading(false);
            Swal.fire({
                icon: "success",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: false,
                timer: 1000,
                html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                showClass: { popup: "animate__animated animate__fadeInDown" },
                hideClass: { popup: "animate__animated animate__fadeOutUp" },
            });
        }).catch(function (error) {
            console.log(error)
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">' + error.response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            })
        });
    };

    const getAbout = async () => {
        setLoading(true);
        await axios
            .get(ENDPOINT + "get-home-about/page-home-about")
            .then((response) => {
                setLoading(false);
                setAboutTitle(response.data.data.about_title);
                setAboutSubTitle(response.data.data.about_sub_title);
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    };

    const handleSubmitAbout = async (e) => {
        e.preventDefault();
        setLoading(true);
        await axios
            .put(ENDPOINT + "update-home-about/page-home-about", {
                about_title: about_title,
                about_sub_title: about_sub_title
            })
            .then((response) => {
                setLoading(false);
                getPageUpdate();
                Swal.fire({
                    icon: "success",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: false,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            })
            .catch(function (error) {
                console.log(error);
                setLoading(true);
                Swal.fire({
                    icon: "error",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: true,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            });
    };

    const getServices = async () => {
        setLoading(true);
        await axios
            .get(ENDPOINT + "get-home-service/page-home-service")
            .then((response) => {
                setLoading(false);
                setServiceTitle(response.data.data.service_title);
                setServiceSubTitle(response.data.data.service_sub_title);
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    };

    const handleSubmitService = async (e) => {
        e.preventDefault();
        setLoading(true);
        await axios
            .put(ENDPOINT + "update-home-service/page-home-service", {
                service_title: service_title,
                service_sub_title: service_sub_title
            })
            .then((response) => {
                setLoading(false);
                getPageUpdate();
                Swal.fire({
                    icon: "success",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: false,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            })
            .catch(function (error) {
                console.log(error);
                setLoading(true);
                Swal.fire({
                    icon: "error",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: true,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            });
    };

    const getDestinations = async () => {
        setLoading(true);
        await axios
            .get(ENDPOINT + "get-home-destination/page-home-destination")
            .then((response) => {
                setLoading(false);
                setDestinationTitle(response.data.data.destination_title);
                setDestinationSubTitle(response.data.data.destination_sub_title);
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    };

    const handleSubmitDestination = async (e) => {
        e.preventDefault();
        setLoading(true);
        await axios
            .put(ENDPOINT + "update-home-destination/page-home-destination", {
                destination_title: destination_title,
                destination_sub_title: destination_sub_title
            })
            .then((response) => {
                setLoading(false);
                getPageUpdate();
                Swal.fire({
                    icon: "success",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: false,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            })
            .catch(function (error) {
                console.log(error);
                setLoading(true);
                Swal.fire({
                    icon: "error",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: true,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            });
    };

    const getDiscover = async () => {
        setLoading(true);
        await axios
            .get(ENDPOINT + "get-home-discover/page-home-discover")
            .then((response) => {
                setLoading(false);
                setDiscoverTitle(response.data.data.discover_title);
                setDiscoverSubTitle(response.data.data.discover_sub_title);
                setDiscoverDescription(response.data.data.discover_description);
                setDiscoverVideo(response.data.data.discover_video);
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    };

    const handleSubmitDiscover = async (e) => {
        e.preventDefault();
        setLoading(true);
        await axios
            .put(ENDPOINT + "update-home-discover/page-home-discover", {
                discover_title: discover_title,
                discover_sub_title: discover_sub_title,
                discover_description: discover_description,
                discover_video: discover_video
            })
            .then((response) => {
                setLoading(false);
                getPageUpdate();
                Swal.fire({
                    icon: "success",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: false,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            })
            .catch(function (error) {
                console.log(error);
                setLoading(true);
                Swal.fire({
                    icon: "error",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: true,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            });
    };

    const getBlogs = async () => {
        setLoading(true);
        await axios
            .get(ENDPOINT + "get-home-blog/page-home-blog")
            .then((response) => {
                setLoading(false);
                setBlogTitle(response.data.data.blog_title);
                setBlogSubTitle(response.data.data.blog_sub_title);
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    };

    const handleSubmitBlog = async (e) => {
        e.preventDefault();
        setLoading(true);
        await axios
            .put(ENDPOINT + "update-home-blog/page-home-blog", {
                blog_title: blog_title,
                blog_sub_title: blog_sub_title
            })
            .then((response) => {
                setLoading(false);
                getPageUpdate();
                Swal.fire({
                    icon: "success",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: false,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            })
            .catch(function (error) {
                console.log(error);
                setLoading(true);
                Swal.fire({
                    icon: "error",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: true,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            });
    };

    const resetPage = () => {
        window.location.reload();
    };

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
            ['link', 'image'],
            ['clean']
        ],
    };

    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image'
    ];

    return (
        <>
            {loading && <Loader />}
            <ContentHeader title="Página Home" />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="page-home-card">
                            <div className="page-home-card-header">
                                <h3 className="page-home-title">
                                    <i className="fas fa-house-user me-2"></i>
                                    Secciones de la Página Home
                                </h3>
                            </div>
                            <ul className="nav nav-tabs page-home-tabs" role="tablist">
                                <li className="nav-item">
                                    <a className="nav-link active" data-bs-toggle="tab" href="#tabs-1" role="tab">
                                        <i className="fas fa-images me-2"></i>Banners
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#tabs-2" role="tab">
                                        <i className="fas fa-building me-2"></i>Nosotros
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#tabs-3" role="tab">
                                        <i className="fas fa-concierge-bell me-2"></i>Servicios
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#tabs-4" role="tab">
                                        <i className="fas fa-map-marker-alt me-2"></i>Destinos
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#tabs-5" role="tab">
                                        <i className="fas fa-compass me-2"></i>Descubre
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#tabs-6" role="tab">
                                        <i className="fas fa-blog me-2"></i>Blog
                                    </a>
                                </li>
                            </ul>

                            <div className="tab-content page-home-tab-content">
                                <div className="tab-pane active" id="tabs-1" role="tabpanel">
                                    <div className="page-home-section-header">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h4 className="page-home-section-title">
                                                <i className="fas fa-image me-2"></i>
                                                Gestión de Banners
                                            </h4>
                                            <div>
                                                <button onClick={handleNew}
                                                    className="btn btn-success btn-sm me-2"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#modal-default">
                                                    <i className="fas fa-plus-circle me-1"></i> Agregar
                                                </button>
                                                <button onClick={resetPage}
                                                    className="btn btn-info btn-sm">
                                                    <i className="fas fa-sync-alt me-1"></i> Recargar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <table className="table table-hover table-striped main table-responsive">
                                            <thead>
                                                <tr>
                                                    <th width="8%" className="text-center">#</th>
                                                    <th width="10%" className="text-left">Titulo</th>
                                                    <th width="40%" className="text-left">Descripción</th>
                                                    <th width="30%" className="text-center">Imagen</th>
                                                    <th width="10%" className="text-center">Estado</th>
                                                    <th width="10%" className="text-center">Opciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {section_banner.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <kbd># {item.page_home_id}</kbd>
                                                        </td>
                                                        <td>
                                                            {item.banner_title}
                                                        </td>
                                                        <td>
                                                            <div dangerouslySetInnerHTML={{ __html: item.banner_sub_title }} />
                                                        </td>
                                                        <td className="text-center">
                                                            <img
                                                                className="rounded border border-secondary img-fluid"
                                                                width={200}
                                                                height={85}
                                                                rounded
                                                                src={item.banner_image ? URLZFILES + item.banner_image : ImageNotFound}
                                                                alt="banner"
                                                            />
                                                        </td>
                                                        <td className="text-center">
                                                            <div data-toggle="tooltip" data-placement="top" title="Estado">
                                                                <Switch
                                                                    checkedIcon={false}
                                                                    uncheckedIcon={false}
                                                                    checked={item.status === 1 ? true : false}
                                                                    onChange={() => toggleSwitch(item.page_home_id)}
                                                                />
                                                            </div>
                                                        </td>
                                                        <td className="text-center">
                                                            <div>
                                                                <button
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#modal-default"
                                                                    className="btn-sm btn btn-warning me-1"
                                                                    onClick={() => handleEdit(item.page_home_id)}
                                                                >
                                                                    <i className="fa-solid fa-pen-to-square"></i>
                                                                </button>
                                                                <button
                                                                    data-bs-toggle="tooltip"
                                                                    data-bs-placement="top"
                                                                    title="Eliminar registro"
                                                                    className="btn-sm btn btn-danger me-1"
                                                                    onClick={() => handleDelete(item.page_home_id, item.banner_title)}
                                                                >
                                                                    <i className="fa-solid fa-trash-can"></i>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="tab-pane" id="tabs-2" role="tabpanel">
                                    <div className="page-home-section-header">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h4 className="page-home-section-title">
                                                <i className="fas fa-building me-2"></i>
                                                Sección de Nosotros
                                            </h4>
                                        </div>
                                    </div>
                                    <div className="table-responsive-container">
                                        <form id="formulario" onSubmit={handleSubmitAbout}>
                                            <div className="row">
                                                <div className="col-12 col-sm-12">
                                                    <div className="form-group">
                                                        <label className="col-form-label col-form-label-sm">Título <span className="page-home-required">*</span></label>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            placeholder="Ingrese título de la sección"
                                                            value={about_title}
                                                            onChange={(e) => setAboutTitle(e.target.value)}
                                                            required
                                                        />
                                                        <small className="page-home-field-hint">Este título aparecerá en la sección Nosotros</small>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-sm-12">
                                                    <div className="form-group">
                                                        <label className="col-form-label col-form-label-sm">Subtítulo <span className="page-home-required">*</span></label>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            placeholder="Ingrese subtítulo de la sección"
                                                            value={about_sub_title}
                                                            onChange={(e) => setAboutSubTitle(e.target.value)}
                                                            required
                                                        />
                                                        <small className="page-home-field-hint">Este subtítulo proporcionará más detalles sobre la sección</small>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 text-end">
                                                    <button type="submit" className="btn btn-primary">
                                                        <i className="fas fa-save me-2"></i>Actualizar
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                                <div className="tab-pane" id="tabs-3" role="tabpanel">
                                    <div className="page-home-section-header">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h4 className="page-home-section-title">
                                                <i className="fas fa-concierge-bell me-2"></i>
                                                Sección de Servicios
                                            </h4>
                                        </div>
                                    </div>
                                    <div className="table-responsive-container">
                                        <form id="formulario" onSubmit={handleSubmitService}>
                                            {/* Similar structure to About section */}
                                            <div className="row">
                                                <div className="col-12 col-sm-12">
                                                    <div className="form-group">
                                                        <label className="col-form-label col-form-label-sm">Título <span className="page-home-required">*</span></label>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            placeholder="Ingrese título de servicios"
                                                            value={service_title}
                                                            onChange={(e) => setServiceTitle(e.target.value)}
                                                            required
                                                        />
                                                        <small className="page-home-field-hint">Título principal para la sección de servicios</small>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-sm-12">
                                                    <div className="form-group">
                                                        <label className="col-form-label col-form-label-sm">Subtítulo <span className="page-home-required">*</span></label>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            placeholder="Ingrese subtítulo de servicios"
                                                            value={service_sub_title}
                                                            onChange={(e) => setServiceSubTitle(e.target.value)}
                                                            required
                                                        />
                                                        <small className="page-home-field-hint">Breve descripción de los servicios ofrecidos</small>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 text-end">
                                                    <button type="submit" className="btn btn-primary">
                                                        <i className="fas fa-save me-2"></i>Actualizar
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                                <div className="tab-pane" id="tabs-4" role="tabpanel">
                                    <div className="page-home-section-header">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h4 className="page-home-section-title">
                                                <i className="fas fa-map-marker-alt me-2"></i>
                                                Sección de Destinos
                                            </h4>
                                        </div>
                                    </div>
                                    <div className="table-responsive-container">
                                        <form id="formulario" onSubmit={handleSubmitDestination}>
                                            {/* Similar structure */}
                                            <div className="row">
                                                <div className="col-12 col-sm-12">
                                                    <div className="form-group">
                                                        <label className="col-form-label col-form-label-sm">Título <span className="page-home-required">*</span></label>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            placeholder="Ingrese título de destinos"
                                                            value={destination_title}
                                                            onChange={(e) => setDestinationTitle(e.target.value)}
                                                            required
                                                        />
                                                        <small className="page-home-field-hint">Título principal para la sección de destinos</small>
                                                    </div>
                                                </div>
                                                {/* Similar structure for subtitle */}
                                                <div className="col-12 col-sm-12">
                                                    <div className="form-group">
                                                        <label className="col-form-label col-form-label-sm">Subtítulo <span className="page-home-required">*</span></label>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            placeholder="Ingrese subtítulo de destinos"
                                                            value={destination_sub_title}
                                                            onChange={(e) => setDestinationSubTitle(e.target.value)}
                                                            required
                                                        />
                                                        <small className="page-home-field-hint">Breve descripción de los destinos ofrecidos</small>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 text-end">
                                                    <button type="submit" className="btn btn-primary">
                                                        <i className="fas fa-save me-2"></i>Actualizar
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                                <div className="tab-pane" id="tabs-5" role="tabpanel">
                                    <div className="page-home-section-header">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h4 className="page-home-section-title">
                                                <i className="fas fa-compass me-2"></i>
                                                Sección de Descubre
                                            </h4>
                                        </div>
                                    </div>
                                    <div className="table-responsive-container">
                                        <form id="formulario" onSubmit={handleSubmitDiscover}>
                                            <div className="row">
                                                {/* Similar fields structure */}
                                                <div className="col-12 col-sm-12">
                                                    <div className="form-group">
                                                        <label className="col-form-label col-form-label-sm">Título <span className="page-home-required">*</span></label>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            placeholder="Ingrese título de descubre"
                                                            value={discover_title}
                                                            onChange={(e) => setDiscoverTitle(e.target.value)}
                                                            required
                                                        />
                                                        <small className="page-home-field-hint">Título principal para la sección de descubre</small>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-sm-12">
                                                    <div className="form-group">
                                                        <label className="col-form-label col-form-label-sm">Subtítulo <span className="page-home-required">*</span></label>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            placeholder="Ingrese subtítulo de descubre"
                                                            value={discover_sub_title}
                                                            onChange={(e) => setDiscoverSubTitle(e.target.value)}
                                                            required
                                                        />
                                                        <small className="page-home-field-hint">Breve descripción de la sección descubre</small>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-sm-12">
                                                    <div className="form-group">
                                                        <label className="col-form-label col-form-label-sm">Descripción <span className="page-home-required">*</span></label>
                                                        <ReactQuill
                                                            theme="snow"
                                                            value={discover_description}
                                                            onChange={setDiscoverDescription}
                                                            modules={modules}
                                                            formats={formats}
                                                            placeholder="Ingrese la descripción detallada"
                                                            className="page-home-editor"
                                                        />
                                                        <small className="page-home-field-hint">Descripción detallada de la sección Descubre</small>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-sm-12">
                                                    <div className="form-group">
                                                        <label className="col-form-label col-form-label-sm">URL del Video <span className="page-home-required">*</span></label>
                                                        <input
                                                            type="url"
                                                            className="form-control form-control-sm"
                                                            placeholder="https://..."
                                                            value={discover_video}
                                                            onChange={(e) => setDiscoverVideo(e.target.value)}
                                                            required
                                                        />
                                                        <small className="page-home-field-hint">URL del video promocional</small>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 text-end">
                                                    <button type="submit" className="btn btn-primary">
                                                        <i className="fas fa-save me-2"></i>Actualizar
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                                <div className="tab-pane" id="tabs-6" role="tabpanel">
                                    <div className="page-home-section-header">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h4 className="page-home-section-title">
                                                <i className="fas fa-blog me-2"></i>
                                                Sección de Blog
                                            </h4>
                                        </div>
                                    </div>
                                    <div className="table-responsive-container">
                                        <form id="formulario" onSubmit={handleSubmitBlog}>
                                            <div className="row">
                                                <div className="col-12 col-sm-12">
                                                    <div className="form-group">
                                                        <label className="col-form-label col-form-label-sm">Título <span className="page-home-required">*</span></label>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            placeholder="Ingrese título del blog"
                                                            value={blog_title}
                                                            onChange={(e) => setBlogTitle(e.target.value)}
                                                            required
                                                        />
                                                        <small className="page-home-field-hint">Título principal para la sección de blog</small>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-sm-12">
                                                    <div className="form-group">
                                                        <label className="col-form-label col-form-label-sm">Subtítulo <span className="page-home-required">*</span></label>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            placeholder="Ingrese subtítulo del blog"
                                                            value={blog_sub_title}
                                                            onChange={(e) => setBlogSubTitle(e.target.value)}
                                                            required
                                                        />
                                                        <small className="page-home-field-hint">Breve descripción de la sección de blog</small>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 text-end">
                                                    <button type="submit" className="btn btn-primary">
                                                        <i className="fas fa-save me-2"></i>Actualizar
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal with improved styling */}
            <div className="modal fade" id="modal-default" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="modal-default" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content page-home-modal">
                        <div className="modal-header">
                            <h4 className="modal-title">
                                <i className="fas fa-image me-2"></i>
                                {page_home_id === 0 ? "Nuevo Banner" : "Editar Banner"}
                            </h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label className="form-label">
                                                Título del Banner <span className="page-home-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                value={banner_title}
                                                onChange={(e) => setBannerTitle(e.target.value)}
                                                placeholder="Ingrese el título del banner"
                                                required
                                            />
                                            <small className="page-home-field-hint">
                                                El título debe ser conciso y llamativo
                                            </small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 mt-3">
                                        <div className="form-group">
                                            <label htmlFor="banner_sub_title" className="col-form-label col-form-label-sm">
                                                Descripción
                                            </label>
                                            <ReactQuill
                                                theme="snow"
                                                value={banner_sub_title}
                                                onChange={setBannerSubTitle}
                                                modules={modules}
                                                formats={formats}
                                                placeholder={'Ingrese descripción'}
                                                className="page-home-editor"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 mt-3">
                                        <div className="form-group">
                                            <label htmlFor="banner_image" className="col-form-label col-form-label-sm">
                                                Imagen (Recomendación: 1550px por 700px)
                                            </label>
                                            <br />
                                            <input
                                                type="file"
                                                name="file"
                                                onChange={handleFileChange}
                                            />
                                        </div>
                                        <img
                                            className="rounded border border-secondary img-fluid mt-3"
                                            width={350}
                                            height={140}
                                            src={banner_image ? URLZFILES + banner_image : ImageNotFound}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="submit"
                                    className="btn btn-success">
                                    <i className="fas fa-save me-1"></i>
                                    {page_home_id === 0 ? "Guardar" : "Actualizar"}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal">
                                    <i className="fa-solid fa-ban me-1"></i>
                                    Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PageHome;